const response_errors = {
  ACCESS_DENIED: "Доступ с текущего IP или по указанным параметрам запрещен",
  AMOUNT_ERROR: "Неверно указана сумма транзакции",
  AMOUNT_EXCEED: "Сумма транзакции превышает доступный остаток средств на выбранном счете",
  AMOUNT_EXCEED_BALANCE: "Сумма транзакции превышает доступный остаток средств на выбранном счете",
  AUTHENTICATION_ERROR: "Ошибка 3D-S аутентификации",
  CARD_NOT_ACTIVE: "Карта не активна",
  COMMUNICATE_ERROR: "Ошибка возникла при передаче данных в МПС",
  CUSTOMER_NOT_FOUND: "Держатель карты не найден",
  DATABASE_TIMEOUT: "Таймаут базы данных",
  DUPLICATE_CARD: "Карта уже зарегистрирована",
  DUPLICATE_ORDER_ID: "Номер заказа уже использовался ранее",
  DUPLICATE_PROCESSING_ORDER_ID: "Номер заказа использовался ранее в процессинге банка",
  DUPLICATE_TERMINAL: "Терминал задублирован",
  DUPLICATE_TRANSACTION_TRACE: "Дублированный статус транзакции",
  EMPTY_RESPONSE: "Ошибка процессинга",
  ENCODING_ERROR: "Ошибка декодирования ответа второстепенной системы",
  FRAUD_ERROR: "Недопустимая транзакция согласно настройкам фильтра антифрода",
  ILLEGAL_ORDER_STATE: "Попытка выполнения недопустимой операции для текущего состояния платежа",
  INTERNAL_ERROR: "Неправильный формат транзакции с точки зрения сети",
  INVALID_AUTHENTICATION: "Некорректная аутентификация",
  INVALID_ENROLLMENT: "Карта не прошла проверку вовлеченности в технологию 3-D Secure",
  INVALID_FORMAT: "Неправильный формат транзакции с точки зрения сети",
  ISSUER_BLOCKED_CARD: "Владелец карты пытается выполнить транзакцию, которая для него не разрешена банком-эмитентом, либо произошла внутренняя ошибка эмитента",
  ISSUER_CARD_FAIL: "Банк-эмитент запретил интернет транзакции по карте",
  ISSUER_FAIL: "Владелец карты пытается выполнить транзакцию, которая для него не разрешена банком-эмитентом, либо внутренняя ошибка эмитента",
  ISSUER_LIMIT_AMOUNT_FAIL: "Предпринята попытка выполнить транзакцию на сумму, превышающую (дневной) лимит, заданный банком-эмитентом",
  ISSUER_LIMIT_COUNT_FAIL: "Превышен лимит на число транзакций: клиент выполнил максимально разрешенное число транзакций в течение лимитного цикла и пытается провести еще одну",
  ISSUER_LIMIT_FAIL: "Предпринята попытка, превышающая ограничения банка-эмитента на сумму или количество операций в определенный промежуток времени",
  ISSUER_TIMEOUT: "Нет связи с банком эмитентом",
  LIMIT_EXCHAUST: "Время или количество попыток, отведенное для ввода данных, исчерпано",
  MERCHANT_NOT_FOUND: "Мерчант не найден",
  MERCHANT_RESTRICTION: "Превышен лимит Магазина или транзакции запрещены Магазину",
  NO_CHAIN: "Не найден инициирующий рекуррент",
  NO_SESSION: "Не найдена сессия",
  NO_TRANSACTION_ID: "Не найдена id_транзакции",
  NONE: "Операция выполнена без ошибок",
  NOT_ALLOWED: "Отказ эмитента проводить транзакцию. Чаще всего возникает при запретах, наложенных на карту",
  NOT_AUTHED: "Ошибка аутентификации",
  NOT_FOUND: "Не найдено",
  ORDER_NOT_FOUND: "Не найдена транзакция",
  SESSION_EXPIRED: "Время платежа (сессии) истекло",
  PAYMENT_ENGINE_ERROR: "Неопознанная ошибка платежного шлюза",
  PROCESSING_ERROR: "Ошибка функционирования системы, имеющая общий характер. Фиксируется платежной сетью или банком-эмитентом",
  PROCESSING_FRAUD_ERROR: "Недопустимая транзауция согласно настрокам фильтра Антифрода в Банке-эквайере",
  PROCESSING_TIME_OUT: "Таймаут в процессинге",
  REAUTH_NOT_ALOWED: "Изменение суммы авторизации не может быть выполнено",
  REFUND_NOT_ALOWED: "Возврат не может быть выполнен",
  TERMINAL_NOT_FOUND: "Терминал не найден",
  THREE_DS_FAIL: "Невозможно выполнить 3DS транзакцию",
  THREE_DS_TIME_OUT: "Срок действия транзакции был превышен к моменту ввода данных карты",
  TRANSACTION_NOT_3DS_PREAUTHORIZED: "Попытка 3DS авторизации по карте non3ds",
  TRANSACTION_NOT_AUTHORIZED: "Транзакция не авторизована",
  TRANSACTION_NOT_CHARGED: "Транзакция не списана",
  TRANSACTION_NOT_FOUND: "Транзакция не найдена",
  TRANSACTION_REFUNDED_OR_REFUNDING: "Транзакция возвращена или находится в процессе возврата",
  TRANSACTION_STATE_CHARGED_OR_CHARGING: "Статус транзакции списан или в процессе списания",
  TRANSACTION_STATE_REJECTED: "Транзакция отклонена",
  TRANSACTION_TRACE_NOT_FOUND: "Статус транзакции не найден",
  TRANSACTION_VOIDED_OR_VOIDING: "Транзакция разблокирована или в процессе разблокировки",
  UNKNOWN_STATE: "Неизвестный статус",
  USER_NOT_FOUND: "Пользователь не найден",
  WRONG_AMOUNT: "Некорректная сумма",
  WRONG_CARD: "Переданы неверные параметры карты, либо карта в недопустимом состоянии",
  WRONG_CARD_EXP: "Некорректный срок действия карты",
  WRONG_CARD_INFO: "Некорректная информация по карте",
  WRONG_CARD_PAN: "Неверный номер карты",
  WRONG_CARDHOLDER_NAME: "Недопустимое имя держателя карты",
  WRONG_CURRENCY: "Некорректная валюта",
  WRONG_PARAMS: "Неверный набор или формат параметров",
  WRONG_PAY_INFO: "Некорректный параметр PayInfo (неправильно сформирован или нарушена криптограмма)",
  WRONG_PHONE: "Некорректный номер телефона",
  message: {
    "default": "Произошла ошибка, попробуйте снова",
    "name is required": "Имя обязательно",
    "ID is required": "ID обязательно",
    "this name is already in use": "Это имя уже используется",
    "error updating merchant into DB": "Ошибка обновления предприятия в БД",
    "password validation failed: password must contain 8-20 latin upper and lower case letters and special chars": "Проверка пароля не удалась: пароль должен содержать 8-20 латинских букв верхнего и нижнего регистра и специальные символы",
    "this merchant already exists": "Это предприятие уже существует",
    "error inserting new merchant into DB": "Ошибка при добавлении нового предприятия в БД",
    "error verify authorization the user": "Ошибка подтверждения авторизации пользователя",
    "user is not admin": "Пользователь не является админом",
    "name is not latin, forbidden": "Имя записано не на латинице",
    "spaces in name are forbidden": "Пробелы в имени запрещены",
    "Human name is required": "Human name обязательно",
    "simultaneous space count is more than 1, forbidden": "Допускается один пробел между словами",
    "this human name already exists": "Это human name уже существует",
    "currency code is required": "Валюта обязательна",
    "error encrypting processing username": "Ошибка шифрования имени пользователя процессинга",
    "error encrypting processing password": "Ошибка шифрования пароля процессинга",
    "error inserting new processing into DB": "Ошибка вставки нового процессинга в БД",
    "error updating processing into DB": "Ошибка обновления процессинга в базе данных",
    "error getting processing by id from cache": "Ошибка получения процессинга по ID из кэша",
    "error marshaling configuration": "Ошибка конфигурации",
    "invalid processing id": "Неправильный ID процессинга",
  }
}

export default response_errors